import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../Hooks/useAuth';

// This component protects routes that require a logged-in user
const PrivateRoute = ({ children }) => {
  const { user } = useAuth(); // Access user information from AuthContext
  const location = useLocation(); // Get the current location

  return user ? children : <Navigate to="/login" state={{ from: location }} />;
};

export default PrivateRoute;
